<template>
  <div class="chart-scene">
    <echarts
      :options="options"
      @over="handleMouseOver"
      @out="handleMouseOut"
      @click="handleClick"
      class="chart-stage"
    ></echarts>
    <!-- <div v-show="showSummary.top" class="summary-top">
      <p class="name">{{data[0].summary.name}}</p>
      <p class="value">{{data[0].summary.value}}</p>
    </div>
    <div v-show="showSummary.left" class="summary-left">
      <p class="name">{{data[1].summary.name}}</p>
      <p class="value">{{data[1].summary.value}}</p>
    </div>
    <div v-show="showSummary.right" class="summary-right">
      <p class="name">{{data[2].summary.name}}</p>
      <p class="value">{{data[2].summary.value}}</p>
    </div>-->
  </div>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/gauge";
import "echarts/lib/component/tooltip";

export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      default() {
        return ["#66c676", "#d3d3d3", "#ffd37c", "#ff7c7c", "#4d9bf9"];
      }
    }
  },
  created() {
    var timer;
    // this.Totalactive = (this.data[0].detail[0].value/this.data[0].summary.value)*100
    // setTimeout(() => {
    //   this.Totalactive = (this.data[0].detail[0].value/this.data[0].summary.value)*100
    //   this.GLactive = (this.data[2].detail[0].value/this.data[2].summary.value)*100
    //   this.PTactive = (this.data[1].detail[0].value/this.data[1].summary.value)*100
    // }, 3500);
    // console.log('this.data',this.data)
    timer = setInterval(() => {
      if(this.data[0].summary.value != 0){
              this.Totalactive =(this.data[0].detail[0].value / this.data[0].summary.value) * 100;
      }else{
        this.Totalactive = 0.00
      }
      if(this.data[2].summary.value != 0){
              this.GLactive =(this.data[2].detail[0].value / this.data[2].summary.value) * 100;
      }else{
        this.GLactive = 0.00
      }
      if(this.data[1].summary.value != 0){
             this.PTactive =(this.data[1].detail[0].value / this.data[1].summary.value) * 100;
      }else{
        this.PTactive = 0.00
      }
      // this.PTactive =
      //   (this.data[1].detail[0].value / this.data[1].summary.value) * 100;
      if (this.Totalactive) {
        clearInterval(timer);
      }
    }, 1000);
  },
  data() {
    return {
      PTactive: 0,
      GLactive: 0,
      Totalactive: 0,
      chartWidth: "100%",
      showSummary: {
        top: true,
        left: true,
        right: true
      } // 是否显示各圆环总计数据
    };
  },
  computed: {
    options() {
      return {
        tooltip: {
          formatter: "{a} <br/>{c} {b}"
        },
        // toolbox: {
        //   show: true,
        //   feature: {
        //     restore: { show: true },
        //     saveAsImage: { show: true }
        //   }
        // },
        series: [
          {
            name: this.$t("statistic.allAccount"),
            type: "gauge",
            z: 3,
            min: 0,
            max: 100,
            splitNumber: 10,
            // startAngle: 225,
            // endAngle: -45,
            center: ["50%", "65%"], // 默认全局居中
            radius: "65%",
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 8,
                color: [[0, "#ff6f11"],[(this.Totalactive/100), "#ff6f11"], [1, "#f0f0f0"]]
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 10, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            splitLine: {
              // 分隔线
              length: 15, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "auto"
              }
            },
            axisLabel: {
              color: "#222D35"
            },
            title: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontSize: 16,
              offsetCenter: [0, "50%"],
              color: "#888"
              // backgroundColor:'pink',
              // width:300,
              // height:50
            },
            pointer: {
              width: 0
              // length: '80%'
            },
            itemStyle: {
              //指针样式
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              formatter: function(value) {
                value = (value + "").split(".");
                value.length < 2 && value.push("0");
                return (
                  ("" + value[0]).slice(-3) +
                  "." +
                  (value[1] + "0").slice(0, 2) +
                  "%"
                );
              },
              fontWeight: "bolder",
              color: "#fff",
              offsetCenter: [0, "0%"],
              fontSize: 20,
              rich: {}
            },
            data: [
              { value: this.Totalactive, name: this.$t("statistic.allAccount") }
            ]
          },
          {
            name: this.$t("statistic.generalAccount"),
            type: "gauge",
            center: ["25%", "35%"], // 默认全局居中
            radius: "55%",
            min: 0,
            max: 100,
            endAngle: 55,
            splitNumber: 10,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 4,
                color: [[0, "#17bfa6"], [(this.PTactive/100), "#17bfa6"], [1, "#f0f0f0"]]
              }
            },
            axisTick: {
              // 坐标轴小标记
              length: 6, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            axisLabel: {
              color: "#222D35"
            },
            splitLine: {
              // 分隔线
              length: 10, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "auto"
              }
            },
            pointer: {
              width: 0
            },
            title: {
              offsetCenter: [0, "-30%"], // x, y，单位px
              fontSize: 14,
              color: "#9d9d9d"
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: "bolder",
              formatter: function(value) {
                value = (value + "").split(".");
                value.length < 2 && value.push("0");
                return (
                  ("" + value[0]).slice(-3) +
                  "." +
                  (value[1] + "0").slice(0, 2) +
                  "%"
                );
              },
              fontSize: 16,
              offsetCenter: [0, "10%"],
              color: "#fff"
            },
            data: [
              {
                value: this.PTactive,
                name: this.$t("statistic.generalAccount")
              }
            ]
          },
          {
            name: this.$t("statistic.adminAccount"),
            type: "gauge",
            center: ["75%", "35%"], // 默认全局居中
            radius: "55%",
            min: 0,
            max: 100,
            startAngle: 125,
            endAngle: -45,
            splitNumber: 10,
            axisLine: {
              // 坐标轴线
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 4,
                color: [[0, "#f0f0f0"],  [(1-(this.GLactive/100)), "#f0f0f0"], [1, "#3f6ed9"]]
              }
            },
            axisTick: {
              // 坐标轴小标记
              splitNumber: 5,
              length: 6, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle控制线条样式
                color: "auto"
              }
            },
            axisLabel: {
              color: "#222D35"
            },
            splitLine: {
              // 分隔线
              length: 10, // 属性length控制线长
              lineStyle: {
                // 属性lineStyle（详见lineStyle）控制线条样式
                color: "auto"
              }
            },
            pointer: {
              width: 0
            },
            title: {
              offsetCenter: [0, "-30%"], // x, y，单位px
              fontSize: 14,
              color: "#9d9d9d"
            },
            detail: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              fontWeight: "bolder",
              formatter: function(value) {
                value = (value + "").split(".");
                value.length < 2 && value.push("0");
                return (
                  ("" + value[0]).slice(-3) +
                  "." +
                  (value[1] + "0").slice(0, 2) +
                  "%"
                );
              },
              fontSize: 16,
              offsetCenter: [0, "10%"],
              color: "#fff"
            },
            data: [
              { value: this.GLactive, name: this.$t("statistic.adminAccount") }
            ]
          }
        ]
      };
    }
  },

  methods: {
    handleMouseOver(block) {
      this.showSummary[block.seriesName] = false;
    },
    handleMouseOut(block) {
      this.showSummary[block.seriesName] = true;
    },
    // 点击区域跳转用户页
    handleClick(param) {
      var parName;
      if (param.name == "Active" || param.name == "活跃") {
        parName = true;
      } else {
        parName = false;
      }
      this.$router.push({
        path: "/adminNew/account",
        query: {
          role:
            param.componentIndex == 1
              ? "0"
              : param.componentIndex == 2
              ? "2"
              : null,
          active: parName ? "true" : "false"
        }
      });
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-scene {
  height: 100%;
  position: relative;
  .chart-stage {
    height: 100%;
  }
  .summary {
    position: absolute;
    transform: translate(-50%, -50%);
    text-align: center;
    font-size: 0.875rem;
    color: #333;
    max-width: 75px;
    .name {
      margin-bottom: 10px;
    }
    .value {
      font-size: 0.013vh;
      // font-size: 20px;
      font-weight: bold;
    }
  }
  .summary-top {
    .summary;
    top: 30%;
    left: 50%;
    font-size: 0.55rem;
  }
  .summary-left {
    .summary;
    top: 70%;
    left: 25%;
    font-size: 0.55rem;
  }
  .summary-right {
    .summary;
    top: 70%;
    left: 75%;
    font-size: 0.55rem;
  }
}
</style>


